import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'; // सही इम्पोर्ट

const Footer: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to handle scroll and show/hide the button
  const toggleVisibility = () => {
    const isMobileViewport = window.matchMedia('(max-width: 575.98px)').matches;
    const threshold = isMobileViewport ? 160 : 300;
    setIsVisible(window.scrollY > threshold);
  };

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  };

  // Add scroll event listener when component mounts
  useEffect(() => {
    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('resize', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', toggleVisibility);
    };
  }, []);

  return (
    <>
      <footer className="footer-section sf-footer text-white py-5">
        <Container>
          <Row className="g-4">
            <Col lg={4} md={6}>
              <h5 className="footer-title">Srisailam Foundation</h5>
              <p className="footer-text">Supporting children&apos;s education, with a vision to reach more communities.</p>
              <p className="footer-text mb-0">Raebareli, Uttar Pradesh, India</p>
            </Col>
            <Col lg={2} md={6}>
              <h5 className="footer-title">About</h5>
              <ul className="list-unstyled">
                <li><a href="/about/" className="footer-link">About Srisailam</a></li>
                <li><a href="/core-team/" className="footer-link">Leadership Team</a></li>
                <li><a href="/mentors/" className="footer-link">Advisory Mentors</a></li>
                <li><a href="/privacy-policy/" className="footer-link">Privacy Policy</a></li>
              </ul>
            </Col>
            <Col lg={2} md={6}>
              <h5 className="footer-title">Programs</h5>
              <ul className="list-unstyled">
                <li><a href="/education/" className="footer-link">Education</a></li>
                <li><a href="/women-empowerment/" className="footer-link">Women Empowerment</a></li>
                <li><a href="/environment/" className="footer-link">Environment</a></li>
                <li><a href="/health/" className="footer-link">Health</a></li>
              </ul>
            </Col>
            <Col lg={4} md={6}>
              <h5 className="footer-title">Contact Us</h5>
              <p className="footer-text mb-2">Raebareli, Uttar Pradesh, India</p>
              <p className="footer-text mb-2"><a href="tel:+919838580001" className="footer-link">+91 98385 80001</a> / <a href="tel:+919450008921" className="footer-link">+91 94500 08921</a></p>
              <p className="footer-text mb-3"><a href="mailto:info@srisailamfoundation.org" className="footer-link">info@srisailamfoundation.org</a></p>
              <div className="d-flex gap-3 sf-footer-socials">
                <a
                  href="https://www.facebook.com/srisailamfoundation.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Visit Srisailam Foundation on Facebook"
                >
                  <FontAwesomeIcon icon={faFacebookF} size="lg" />
                </a>
                <a
                  href="https://x.com/srisailamfndn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Visit Srisailam Foundation on X"
                >
                  <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Visit Srisailam Foundation on YouTube"
                >
                  <FontAwesomeIcon icon={faYoutube} size="lg" />
                </a>
                <a
                  href="https://www.instagram.com/srisailamfoundation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Visit Srisailam Foundation on Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} size="lg" />
                </a>
              </div>
            </Col>
          </Row>
          <hr className="footer-divider my-4" />
          <p className="footer-note mb-0 text-center">
            © {new Date().getFullYear()} Srisailam Foundation. All rights reserved.
          </p>
        </Container>
      </footer>

      {/* Jump to Top Button */}
      <button
        type="button"
        onClick={scrollToTop}
        className={`jump-to-top ${isVisible ? 'visible' : ''}`}
        title="Back to top"
        aria-label="Scroll to top"
      >
        <FontAwesomeIcon icon={faChevronUp} size="lg" />
      </button>
    </>
  );
};

export default Footer;
